const chartId = "chart-12"
let Chart = require('chart.js');
Chart.defaults.global.defaultFontFamily = 'acumin-pro';
const colors = require('../../../colors');
const data = require('./data');
const _groupBy = require('lodash/groupBy')
const _each = require('lodash/each')

let hues = [
  colors.secondary["orange"][100].rgba,
  colors.secondary["orange"][60].rgba,
  colors.secondary["yellow"][100].rgba,
  colors.secondary["yellow"][60].rgba,
  colors.secondary["blue"][40].rgba,
  colors.secondary["blue"][60].rgba,
  colors.secondary["blue"][100].rgba,
]

let borders = hues.map(x=>x.replace("1)",".7)"));
const groupedData = _groupBy(data, "LE");

var i = 0;
let labels = Array.from({ length: 7 }, function() {
  i++;
  return 74 + i;
})

let dataset = {
  label: 'Total States',
  data: [],
  backgroundColor: hues,
  borderColor: borders,
  borderWidth: 1
}

_each(groupedData, function(group) {
  dataset.data.push(group.length)
})
dataset.data.push(2)

let ctx = document.getElementById(chartId).getContext('2d');
new Chart(ctx, {
  type: 'bar',
  data: {
    labels: labels,
    datasets: [dataset]
  },
  options: {
    legend: {
      display: false
    },
    responsive: true,
    aspectRatio: 5,
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true
        }
      }]
    }
  }
})
